
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import Radio from 'element-ui/lib/radio';

var script = {
  name: 'PendoRadio',
  components: {
    ElRadio: Radio
  },
  props: {
    value: {
      type: null,
      default: null
    },
    displayClass: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: null
    },
    selected: {
      type: Boolean,
      default: false
    },
    selectedDetails: {
      type: [Boolean, Object],
      default: false
    }
  },
  computed: {
    showSelectedDetails() {
      if (!this.$slots.selectedDetails && !this.selectedDetails) {
        return false;
      }

      return this.selected;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-radio"
  }, [_c('el-radio', {
    class: _vm.displayClass,
    attrs: {
      "label": _vm.value,
      "name": _vm.name,
      "disabled": _vm.disabled
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _vm.showSelectedDetails ? [_vm.selectedDetails.header || _vm.selectedDetails.content ? _c('div', {
    staticClass: "pendo-radio__selected-details",
    class: {
      'has-slot-content': !!_vm.$slots.selectedDetails
    },
    on: {
      "keydown": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.selectedDetails.header ? _c('div', {
    staticClass: "pendo-radio__selected-details-header"
  }, [_vm._v("\n                " + _vm._s(_vm.selectedDetails.header) + "\n                "), _vm.selectedDetails.link ? _c('a', {
    staticClass: "pendo-radio__selected-details-link",
    attrs: {
      "href": _vm.selectedDetails.link.url,
      "target": "_blank"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.selectedDetails.link.label) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.selectedDetails.content ? _c('div', {
    staticClass: "pendo-radio__selected-details-content"
  }, [_vm._v("\n                " + _vm._s(_vm.selectedDetails.content) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._t("selectedDetails")], 2) : _vm._e(), _vm._v(" "), !_vm.selectedDetails.header && !_vm.selectedDetails.content ? _vm._t("selectedDetails") : _vm._e()] : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-radio.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoRadio = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoRadio;
